import { List } from "@mui/material";
import * as React from "react";
import { ITreeNode, TreeNode } from "ui/Scripts/source/models/common/treeNode";
import { UiTreeNode } from "../UiTreeNode";

export interface IUiTreeProp {
    classes?: string;
    firstColumnTitle: string;
    nodes: ITreeNode[];
    selectedId?: string;
    isFirstNode: boolean;
    hideDisabledIcon?: boolean;
    onClick: (id: string) => void;
    onDoubleClick?: () => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export interface IUiTreeState {
    nodes: ITreeNode[];
}

export class UiTree extends React.Component<IUiTreeProp, IUiTreeState> {
    constructor(props: IUiTreeProp) {
        super(props);
        this.state = {
            nodes: props.nodes.map(i => new TreeNode(i))
        };
    }
    
    render() {
        const props = this.props;
        const nodes = props.nodes;
        if (!nodes) return null;
        return (
            <List>
                {nodes.map((node, index) =>
                    <UiTreeNode
                        key={node.id}
                        node={node}
                        selectedId={props.selectedId}
                        isFirstNode={index < 1}
                        onClick={props.onClick}
                        hideDisabledIcon={props.hideDisabledIcon}
                        onDoubleClick={props.onDoubleClick}
                        onSetCollapsed={props.onSetCollapsed}
                    />
                )}
            </List>
        );
    }
}